/**
 * Transonic enquiry form functionality.
 *
 * @author    Mark Shercliff <mark@bareface.agency>
 * @copyright 2016 Bareface
 */
;(function($, window, undefined) {
    $('#gform_11').submit(function(e) {
        e.preventDefault();

        var $form = $(this);
        $form.find('input, select, textarea').attr('disabled', 'disabled');
        $form.find('.form__error-message').text('').animate({
        }, 150);

        $.ajax({
            url:      window.ajaxurl,
            method:   'post',
            dataType: 'json',
            data:     {
                action:    'kimal_ajax_gform_submit',
                form_id:   11,
                form_data: {
                    input_0: $form.find('[name="input_0"]').val(),
                    input_1: $form.find('[name="input_1"]').val(),
                    input_2: $form.find('[name="input_2"]').val(),
                    input_3: $form.find('[name="input_3"]').val(),
                    input_4: $form.find('[name="input_4"]').val(),
                    input_5: $form.find('[name="input_5"]').val(),
                    input_6: $form.find('[name="input_6"]').val(),
                    input_7: $form.find('[name="input_7"]').val()
                },
                nonce: $form.find('[name="nonce"]').val()
            },

            success: function(response) {
                $form.find('input, select, textarea').removeAttr('disabled');

                if (response.message) {
                    $form[0].reset();
                    $form.find('.form__confirmation-message').html(response.message);
                }
            },

            error: function(response) {
                $form.find('input, select, textarea').removeAttr('disabled');

                if (response.responseJSON && response.responseJSON.errors) {
                    $.each(response.responseJSON.errors, function(key, error) {
                        $form.find('.form__error-message[data-for="' + key + '"]').text(error).slideDown();
                    });
                }
            }
        });
    });

    $('#gform_11 [name="input_11_5"]').selectmenu({
        select: function(e, ui) {
            $('#nature-of-work-text').text(ui.item.label);
        }
    });

    $('#gform_11 [name="input_11_6"]').selectmenu({
        select: function(e, ui) {
            $('#nature-of-fault-text').text(ui.item.label);
        }
    });
})(jQuery, window);
